import React, { startTransition, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import './style/style.css'
import { useTranslation } from 'react-i18next';
import PbxAuthModal from "../pbx/components/common/PbxAuthModal";
import MyExtensionModal from "../pbx/components/MyExtensionModal";

const Sidebar = ({ isVisible, toggleSidebar }) => {
  // const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()
  const [isChartsOpen, setIsChartsOpen] = useState(false);
  const [isActivityOpen, setIsActivityOpen] = useState(false);
  const [isProjectOpen, setIsProjectOpen] = useState(false);
  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false);
  const [isEmployeeOpen, setIsEmployeeOpen] = useState(false);
  const [isporeport, setIsporeport] = useState(false);
  const [isPbxOpen, setIsPbxOpen] = useState(false);

  const [isKT, setIsKT] = useState(false);
  const [language, setlanguage] = useState(localStorage.getItem("lang"));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('token')))
  const [Role, setRole] = useState(JSON.parse(localStorage.getItem('token'))?.role_access_data)
  const [readableRoutes, setReadableRoutes] = useState([]);
  const [isPbxUnlocked, setIsPbxUnlocked] = useState(
    sessionStorage.getItem('pbx_unlocked') === 'true' && Boolean(localStorage.getItem('pbx_cookie'))
  );
  const [showPbxAuthModal, setShowPbxAuthModal] = useState(false);
  const [showExtensionModal, setShowExtensionModal] = useState(false);

  const isAdmin = user?.type == 1 || localStorage.getItem('userType') === '1' || user?.role === 'admin';

  const togglePbx = () => {
    if (!isPbxUnlocked) {
      setShowPbxAuthModal(true);
    } else {
      setIsPbxOpen(!isPbxOpen);
    }
  };
  useEffect(() => {
    const rawMenu = Role?.menu || Role || [];
    if (Array.isArray(rawMenu)) {
      setReadableRoutes(rawMenu);
    } else if (typeof rawMenu === 'object' && rawMenu !== null) {
      setReadableRoutes(Object.keys(rawMenu).filter(key => rawMenu[key]?.read === true));
    }
    console.log("Sidebar Debug:", { userType: user?.type, lsUserType: localStorage.getItem('userType'), readableRoutes: Array.isArray(rawMenu) ? rawMenu : Object.keys(rawMenu || {}) });
  }, [Role]);
  const toggleCharts = () => {
    setIsChartsOpen(!isChartsOpen);// Close Dashboard dropdown if open
  };
  const toggleActivity = () => {
    setIsActivityOpen(!isActivityOpen)
  }

  const EmployeeToggle = () => {
    setIsEmployeeOpen(!isEmployeeOpen)
  }

  const toggleProject = () => {
    setIsProjectOpen(!isProjectOpen)
  }
  const toggleAttendance = () => {
    setIsAttendanceOpen(!isAttendanceOpen)
  }
  const toggleporeport = () => {
    setIsporeport(!isporeport)
  }
  const toggleKT = () => {
    setIsKT(!isKT)
  }
  const { t } = useTranslation();
  const toggleDataAttribute = () => {
    const htmlElement = document.documentElement;
    if (htmlElement.getAttribute('data-toggled') === 'open') {
      htmlElement.setAttribute('data-toggled', 'close');
    } else {
      htmlElement.setAttribute('data-toggled', 'open');
    }
  };

  const handleIconClickvalue = () => {
    if (window.innerWidth < 768) {
      toggleDataAttribute();
    }
  };

  const Sidebar = [
    {
      Name: t('User_Management'),
      img: "/images/icons/UserManage.png",
      route: '0'
    },
    {
      Name: t('Employee'),
      img: "/images/icons/employee.png",
      route: '5'
    },
    {
      Name: t('Activity_Tracking'),
      img: "/images/icons/UserActivity.png",
      route: '1'
    },
    {
      Name: t('Project_Management'),
      img: "/images/icons/UserProject.png",
      route: '2'
    },
    {
      Name: t('Report'),
      img: "/images/icons/attendance.png",
      route: '6'
    },
    {
      Name: t('Attendance'),
      img: "/images/icons/attendance.png",
      route: '/attendence'
    },
    // {
    //   Name: t('Whitelist App'),
    //   img: "/images/icons/attendance.png",
    //   route: '/white_list'
    // },
    {
      Name: t('knowlegeTransfer'),
      img: "/images/icons/calendar.png",
      route: '4'
    },
    {
      Name: t('Timesheet'),
      img: "/images/icons/calendar.png",
      route: '/timesheet'
    }
  ]

  const UserManagement = [
    {
      Name: t('Department'),
      img: "/images/icons/it-department.png",
      route: '/department'
    },
    {
      Name: t('Role_Access'),
      img: "/images/icons/roles_access.png",
      route: '/role-access'
    },
    {
      Name: t('Screenshot_Interval'),
      img: "/images/icons/responsive.png",
      route: '/screen-interval'
    },
    {
      Name: t('Calendar'),
      img: "/images/icons/calendar.png",
      route: '/calendar'
    },
    {
      Name: t('Schedule'),
      img: "/images/icons/shift.png",
      route: '/schedule'
    }
  ];

  const Activity = [
    {
      Name: t('Application'),
      img: "/images/icons/activitys.png",
      route: '/application-track'
    },
    {
      Name: t('URL'),
      img: "/images/icons/url.png",
      route: '/Url-track'
    },
    {
      Name: t('Screenshots'),
      img: "/images/icons/captures.png",
      route: '/screen-shots'
    },
    {
      Name: t('Case_Tracking'),
      img: "/images/icons/managment.png",
      route: '/case_tracking'
    },
    {
      Name: t('Location'),
      img: "/images/icons/locations.png",
      route: '/locations'
    }
  ];

  const ProjectManagement = [
    {
      Name: t('Client'),
      img: "/images/icons/client.png",
      route: '/client'
    },
    {
      Name: t('Projects'),
      img: "/images/icons/managment.png",
      route: '/project'
    },
    {
      Name: t('Task_Tracking'),
      img: "/images/icons/managment.png",
      route: '/task_tracking'
    },
    {
      Name: t('To_Dos'),
      img: "/images/icons/todo.png",
      route: '/todo'
    }
  ];

  const Attendance = [
    {
      Name: t('Attendance'),
      img: "/images/icons/attendance.png",
      route: '/attendence'
    },
  ];

  const Report = [
    {
      Name: t("Tasks") + " " + t("Reports"),
      img: "/images/icons/responsive.png",
      route: '/task-report',
      accessCheck: '/employee-activity'
    },
    {
      Name: t('Overall_Report'),
      img: "/images/icons/activitys.png",
      route: '/overall-employee-report'
    },
    {
      Name: t('Project_Report'),
      img: "/images/icons/managment.png",
      route: '/project-report',
      accessCheck: '/project'
    },
  ];

  const KT_BAR = [
    {
      Name: t('Category'),
      img: "/images/icons/allocated.png",
      route: '/category'
    },
    {
      Name: t('knowlegeTransfer'),
      img: "/images/icons/exchange-ideas.png",
      route: '/kt-view'
    },
  ];

  const Employeeside = [
    {
      Name: t('Employee'),
      img: "/images/icons/employee.png",
      route: '/employee'
    },
    {
      Name: t('PendingDevice'),
      img: "/images/icons/responsive.png",
      route: '/pending-device'
    },
    {
      Name: t('ConfiguredDevice'),
      img: "/images/icons/responsive.png",
      route: '/configured-device'
    },
    {
      Name: t('Screenshot_Assignment'),
      img: "/images/icons/captures.png",
      route: '/screenshot-assignment'
    },
  ]

  const PBXManagement = [
    { Name: t('PBX_Dashboard'), route: '/pbx/dashboard', img: '/images/icons/dashboard.png' },
    { Name: t('Call_History_CDR'), route: '/pbx/call-history', img: '/images/icons/activitys.png' },
    { Name: t('Active_Calls'), route: '/pbx/active-calls', img: '/images/icons/activitys.png' },
    { Name: t('Extensions'), route: '/pbx/extensions', img: '/images/icons/employee.png' },
    { Name: t('Call_Forwarding'), route: '/pbx/call-forwarding', img: '/images/icons/shift.png' },
    { Name: t('Ring_Groups'), route: '/pbx/ring-groups', img: '/images/icons/team-management.png' },
    { Name: t('Queues'), route: '/pbx/queues', img: '/images/icons/UserManage.png' }
  ];

  useEffect(() => {
    const matchedRoute = UserManagement.some(item => item.route === location.pathname);
    const isActivityRoute = Activity.some(item => item.route === location.pathname);
    const isProjectRoute = ProjectManagement.some(item => item.route === location.pathname);
    const isPbxRoute = location.pathname.startsWith('/pbx');
    setIsChartsOpen(matchedRoute);
    setIsActivityOpen(isActivityRoute);
    setIsProjectOpen(isProjectRoute);
    if (isPbxRoute) setIsPbxOpen(true);
  }, [location.pathname]);

  return (
    <aside className={`app-sidebar ${isVisible ? 'sidebar-open' : ''}`} id="sidebar">
      <div className="main-sidebar-header">
        <a className="header-logo">
          <img
            src="/assets/images/brand-logos/kefa'ah.png"
            // src="/images/logos/Artboard 2.png"
            alt="logo"
            className="desktop-logo"
            // style={{ width: "110px", height: "95px" }}
            style={{ width: "150px", height: "56px" }}
          />
          <img
            src="/assets/images/brand-logos/toggle-logo.png"
            alt="logo"
            className="toggle-logo"
          />
          <img
            src="/assets/images/brand-logos/desktop-dark.png"
            alt="logo"
            className="desktop-dark"
          />
          <img
            src="/assets/images/brand-logos/toggle-dark.png"
            alt="logo"
            className="toggle-dark"
          />
          <img
            src="/assets/images/brand-logos/desktop-white.png"
            alt="logo"
            className="desktop-white"
          />
        </a>
      </div>
      <div className="main-sidebar pt-3" id="sidebar-scroll">
        <div className="w-100 d-flex justify-content-between px-3 py-1">
          <span className="side-menu__label">Hi, {user?.name}</span>
          <a className="d-block d-md-block d-lg-none" onClick={toggleSidebar}><i class="ri ri-close-large-fill" aria-hidden="true"></i></a>
        </div>
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <div className="slide-left" id="slide-left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#7b8191"
              width={24}
              height={24}
              viewBox="0 0 24 24"
            >
              <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
            </svg>
          </div>
          <ul className="main-menu">
            <li className="slide" onClick={() => {
              startTransition(() => {
                navigate('/dashboard')
              })
            }}
            >
              <a className={`side-menu__item ${location.pathname == '/dashboard' ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                <img src='/images/icons/dashboard.png' style={{ width: 18, height: 18 }} alt="Employee" />
                <span className={`txt-sidebar`} style={{ color: location.pathname == '/dashboard' ? '#000000' : '' }}> {t('dashboard')}</span>
              </a>
            </li>
            {Sidebar.map((item, index) => (
              <li className="slide" key={index}>
                {UserManagement.find((item, index) => [...readableRoutes, ...["/pending-device"]]?.includes(item.route)) && item.route == "0" ? (
                  <>
                    <a
                      className="side-menu__item"
                      onClick={() => toggleCharts()}
                    >
                      <img src="/images/icons/UserActivity.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className=" ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isChartsOpen ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isChartsOpen ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a>Charts</a>
                      </li>
                      {UserManagement.filter((data, index) => [...readableRoutes, ...["/pending-device"]]?.includes(data.route)).map(item => (
                        <li
                          className="slide"
                          onClick={() => {
                            startTransition(() => {
                              console.log(item.route)
                              navigate(item.route)
                            })
                          }}>
                          <a
                            className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`}
                            onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 25, height: 25 }} alt="Employee" />
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : Employeeside.find((item, index) => [...readableRoutes, ...["/pending-device", "/configured-device"]]?.includes(item.route)) && item.route == "5" ? (
                  <>
                    <a className="side-menu__item" onClick={() => EmployeeToggle()}>
                      <img src="/images/icons/team-management.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className="ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isEmployeeOpen ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isEmployeeOpen ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a >Charts</a>
                      </li>

                      {Employeeside.filter((data, index) => [...readableRoutes, ...["/pending-device", "/configured-device", "/screenshot-assignment"]]?.includes(data.route)).map(item => (
                        <li className="slide" onClick={() => {
                          startTransition(() => {
                            navigate(item.route)
                          })
                        }}>
                          <a className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 22, height: 22 }} alt="Employee" />
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : Activity.find((item, index) => readableRoutes?.includes(item.route)) && item.route == "1" ? (
                  <>
                    <a className="side-menu__item" onClick={() => toggleActivity()}>
                      <img src="/images/icons/ActivityUser.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className="ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isActivityOpen ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isActivityOpen ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a >Charts</a>
                      </li>
                      {Activity.filter((data, index) => readableRoutes?.includes(data.route)).map(item => (
                        <li className="slide" onClick={() => {
                          startTransition(() => {
                            navigate(item.route)
                          })
                        }}>
                          <a className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 22, height: 22 }} alt="Employee" />
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : ProjectManagement.find((item, index) => readableRoutes?.includes(item.route)) && item.route == "2" ? (
                  <>
                    <a className="side-menu__item" onClick={() => toggleAttendance()}>
                      <img src="/images/icons/UserProject.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className="ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isAttendanceOpen ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isAttendanceOpen ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a >Charts</a>
                      </li>
                      {ProjectManagement.filter((data, index) => readableRoutes?.includes(data.route)).map(item => (
                        <li className="slide" onClick={() => {
                          startTransition(() => {
                            navigate(item.route)
                          })
                        }}>
                          <a className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 22, height: 22 }} alt="Employee" />
                            {console.log('Name', item.Name)}
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : Attendance.find((item, index) => readableRoutes?.includes(item.route)) && item.route == "3" ? (
                  <>
                    <a className="side-menu__item" onClick={() => toggleProject()}>
                      <img src="/images/icons/calendar1.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className="ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isProjectOpen ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isProjectOpen ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a >Charts</a>
                      </li>

                      {Attendance.filter((data, index) => readableRoutes?.includes(data.route)).map(item => (
                        <li className="slide" onClick={() => {
                          startTransition(() => {
                            navigate(item.route)
                          })
                        }}>
                          <a className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 22, height: 22 }} alt="Employee" />
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (user?.type == 1 || localStorage.getItem('userType') == '1' || Report.find((item, index) => readableRoutes?.includes(item.accessCheck || item.route))) && item.route == "6" ? (
                  <>
                    <a className="side-menu__item" onClick={() => toggleporeport()}>
                      <img src="/images/icons/calendar1.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className="ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isporeport ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isporeport ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a >Charts</a>
                      </li>
                      {Report.filter((data, index) => user?.type == 1 || localStorage.getItem('userType') == '1' || readableRoutes?.includes(data.accessCheck || data.route)).map(item => (
                        <li className="slide" onClick={() => {
                          startTransition(() => {
                            navigate(item.route)
                          })
                        }}>
                          <a className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 22, height: 22 }} alt="Employee" />
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (user?.type == 1 || KT_BAR.some((item) => readableRoutes?.includes(item.route))) && item.route == "4" ? (
                  <>
                    <a className="side-menu__item" onClick={() => toggleKT()}>
                      <img src="/images/icons/knowledge.png" className={`${language == 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                      <span className="ml-2 txt-sidebar">{item.Name}</span>
                      <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isKT ? 'rotateZ' : ''}`} />
                    </a>
                    <ul className={`slide-menu ${isKT ? 'd-block' : 'd-none'} child1`}>
                      <li className="slide side-menu__label1">
                        <a >Charts</a>
                      </li>
                      {KT_BAR.filter((data, index) => true).map(item => (
                        <li className="slide" onClick={() => {
                          startTransition(() => {
                            navigate(item.route)
                          })
                        }}>
                          <a className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`} onClick={() => { handleIconClickvalue() }}>
                            <img src={item.img} style={{ width: 22, height: 22 }} alt="Employee" />
                            <span className={`txt-sidebar`} style={{ color: location.pathname == item.route ? '#000000' : '' }}>{item.Name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : Sidebar.find(data => [...readableRoutes, ...["/employee-log"]].includes(data.route) && item.route == data.route) && (
                  <a
                    onClick={() => {
                      handleIconClickvalue(); // Toggle the attribute
                      startTransition(() => {
                        navigate(item.route); // Then navigate
                      });
                    }} className={`side-menu__item ${location.pathname == item.route ? "side_menu_active" : ""} gap-3`}>
                    <img src={item.img} style={{ width: 22, height: 22 }} alt={item.Name} />
                    <span className={`txt-sidebar ${location.pathname == item.route ? 'active' : ''}`}>{item.Name}</span>
                  </a>
                )}
              </li>
            ))}


            {(isAdmin || readableRoutes?.some(r => r === '/pbx' || r?.startsWith('/pbx'))) && (
              <li className="slide">
                <a className="side-menu__item d-flex align-items-center" onClick={togglePbx} style={{ cursor: 'pointer' }}>
                  <img src="/images/icons/activitys.png" className={`${language === 'ar' ? 'ml-2' : 'mr-2'}`} alt="" style={{ width: 22, height: 22 }} />
                  <span className="ml-2 txt-sidebar">{t('PBX_Management')}</span>
                  <i 
                    className={`ri-lock-${isPbxUnlocked ? 'unlock-fill text-success' : 'fill text-warning'} ms-auto me-2`} 
                    style={{ fontSize: '16px' }}
                    title={isPbxUnlocked ? 'Unlocked' : 'Locked (Click to authenticate)'}
                  />
                  <i className={`fe fe-chevron-right txt-sidebar side-menu__angle ${isPbxOpen ? 'rotateZ' : ''}`} />
                </a>
                <ul className={`slide-menu ${isPbxOpen ? 'd-block' : 'd-none'} child1`}>
                  <li className="slide side-menu__label1">
                    <a>PBX</a>
                  </li>
                  {PBXManagement.map((item, index) => (
                    <li
                      key={index}
                      className="slide"
                      onClick={() => {
                        if (!isPbxUnlocked) {
                          setShowPbxAuthModal(true);
                        } else {
                          startTransition(() => {
                            navigate(item.route);
                          });
                        }
                      }}
                    >
                      <a
                        className={`side-menu__item ${location.pathname === item.route ? "side_menu_active" : ""} gap-3`}
                        onClick={handleIconClickvalue}
                      >
                        <img src={item.img} style={{ width: 20, height: 20 }} alt={item.Name} />
                        <span className="txt-sidebar" style={{ color: location.pathname === item.route ? '#000000' : '' }}>
                          {item.Name}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            )}

            {(isAdmin || readableRoutes?.some(r => r === '/my-extension' || r === '/pbx' || r?.startsWith('/pbx'))) && (
              <li className="slide">
                <a 
                  className="side-menu__item gap-3"
                  onClick={() => setShowExtensionModal(true)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src="/images/icons/employee.png" style={{ width: 22, height: 22 }} alt="My Extension" />
                  <span className="txt-sidebar">{t('My_Extension')}</span>
                </a>
              </li>
            )}

            <li className="slide">
              <a className="side-menu__item  gap-3"
                onClick={() => window.location.href = `https://${window.location.hostname}:8443/media/kafaa/KAFAA.exe`} target="_blank">
                <img
                  src="/images/icons/activitys.png"
                  alt="Timesheet"
                  style={{ width: 22, height: 22 }}
                />
                <span className="txt-sidebar "> {t('Download_KAFAA')}</span>
              </a>
            </li>
          </ul>
          <div className="slide-right" id="slide-right">
          </div>
        </nav>
      </div>

      <PbxAuthModal 
        show={showPbxAuthModal} 
        onHide={() => setShowPbxAuthModal(false)} 
        onSuccess={() => { 
          setIsPbxUnlocked(true); 
          setIsPbxOpen(true); 
          navigate('/pbx/dashboard'); 
        }} 
      />

      <MyExtensionModal 
        show={showExtensionModal} 
        onClose={() => setShowExtensionModal(false)} 
        onSaved={(ext) => {
          window.dispatchEvent(new CustomEvent('extensionUpdated', { detail: { extension: ext } }));
        }}
      />
    </aside>
  );
};

export default Sidebar;
